import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceMilestoneEditionNotificationState = createStateReducer(
  initialState,
  {
    [events.editMilestoneSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editMilestone",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editMilestoneFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editMilestone",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceMilestoneEditionNotificationState };
